import { Header } from '@header/entities/header-type';
import { DsHeaderConfig } from '@header/entities/ds-header-config';

export const headerFeatureName = 'headerModuleState';

export type HeaderState = Readonly<{
  headerStyle: Header;
  dsHeaderConfig: DsHeaderConfig;
}>;
